import { apiClient } from '@api/client';
import type {
  IntermediaryAnalyticsDataResponse,
  IntermediaryAnalyticsFilters,
} from '@models/intermediaryAnalytics';

export async function getIntermediaryAnalytics(
  filters: IntermediaryAnalyticsFilters,
): Promise<IntermediaryAnalyticsDataResponse> {
  const { data } = await apiClient.get<IntermediaryAnalyticsDataResponse>(
    '/intermediary-analytics',
    {
      params: filters,
    },
  );

  return data;
}
